import { render, staticRenderFns } from "./DetailsDriver.vue?vue&type=template&id=642fa360&"
import script from "./DetailsDriver.vue?vue&type=script&lang=ts&"
export * from "./DetailsDriver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports